const DefaultContainer = () => import('@/containers/DefaultContainer');
import BrandName from "./BrandName/BrandName";
import NDCDetails from "./NDC/NDCDetails"
import DrugDetail from "./BrandName/Details/DrugDetails"
const drugDatabaseRoute = {
    path: '/drugDatabase',
    redirect: '/drugDatabase',
    component: DefaultContainer,
    children: [
        {
            path: 'brandName',
            component: BrandName
        },
        {
            path: "brandName/edit/:id",
            component: DrugDetail

        },
        {
            path: "brandName/add",
            component: DrugDetail

        },
        {
            path: 'ndc',
            component: NDCDetails
        }
    ]
};

export default drugDatabaseRoute;
